module.exports = __webpack_public_path__ + "static/img/49.af8acef.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Office365Deployment/49.png
// module id = nCgk
// module chunks = 1